<template>
  <!-- 外部产品管理 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ close: !searchMore }">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" transfer clearable filterable>
            <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">产品编码</span>
          <Input v-model="searchParams.productCode" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <RadioGroup v-model="searchParams.sellType" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">网销</Radio>
            <Radio label="3">经代</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">险种分类</span>
          <Select v-model="searchParams.themeId" placeholder="请选择" clearable>
            <Option v-for="item in productThemeList" :key="item.id" :value="item.id" :label="item.name"> </Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">投保地区</span>
          <select-region  :requestParams='{"platType":"1"}' requestType='GET' v-model="searchParams.cityCodeList" url='/buz/area/orgProductAreaTree' :checkAllData="true" ref="selectRegion"></select-region>
        </div>
        <div class="input-item">
          <span class="label">长短险标志</span>
          <RadioGroup v-model="searchParams.productType" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">长险</Radio>
            <Radio label="2">短险</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="$units.superviseShowVal()">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保司</Radio>
            <Radio label="2">通道</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="searchParams.supplierType && $units.superviseShowVal()">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">是否有代理协议</span>
          <RadioGroup v-model="searchParams.hasCovenant" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">上架状态</span>
          <RadioGroup v-model="searchParams.publishStatus" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="2">已上架</Radio>
            <Radio label="1">已下架</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否可售产品</span>
          <RadioGroup v-model="searchParams.salesStatus" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="2">是</Radio>
            <Radio label="1">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否有费率</span>
          <RadioGroup v-model="searchParams.isThereRate" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>
      <div class="btn-wrap">
        <Button v-if="$units.pointAction('pro_2_1')" type="primary" @click="showEdit()">新增</Button>
        <Button v-if="$units.pointAction('pro_2_4')" type="warning" @click="toProductList()">产品总库导入</Button>
        <Button v-if="$units.pointAction('pro_2_8') && $units.superviseShowVal()" type="primary" @click="exportToExcel()" ghost>导出产品</Button>
        <Button v-if="$units.pointAction('pro_2_9') && $units.superviseShowVal()" type="primary" @click="exportFee()" ghost>导出当前费率</Button>
        <Button v-if="$units.pointAction('pro_2_11') && $units.superviseShowVal()" type="primary" @click="exportHistoryFee()" ghost>导出历史费率</Button>
        <Button v-if="$units.pointAction('pro_2_12')" type="primary" @click="importData">批量导入</Button>
        <!-- <Button type="primary" @click="importProductFee">导入费率</Button> -->
        <span v-if="userInfo.userType != 4" @click="info = true" class="explain-btn">
          <span>商品服务费率说明</span>
          <Icon type="ios-arrow-forward" color="#236dff" />
        </span>
      </div>
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" :disabled="listLoading" @on-change="selectAll">全部产品</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >项,共<span>{{ total }}</span
            >款产品</span
          >
          <Button :disabled="listLoading" type="primary" @click="batch(true)" ghost>批量上架</Button>
          <Button :disabled="listLoading" type="primary" ghost @click="batch(false)">批量下架</Button>
        </div>
      </div>
      <div class="tableBox setTable">
        <loading :isShow="listLoading" />
        <div class="tableBox">
          <Table :columns="columns" :data="tableData" row-key="id" @on-selection-change="selectRow">
            <template slot-scope="{ row }" slot="productName">
              <div class="product-name">
                <div class="huo" v-if="row.activityInfoList.length">
                  <img src="@/static/images/activity-huo.png" />
                </div>
                <div @click="$units.pointAction('pro_2_2') && showEdit(row)" class="pro-box">
                  <span>{{ row.productName }}</span>
                  <!-- 预售 -->
                  <img class="tag-icon" v-if="row.preSale == 1" src="@static/images/product/icon_ys.png" />
                  <div class="tag" v-if="row.salesStatus == 1">不可售</div>
                </div>
              </div>
            </template>
            <template slot-scope="{ row }" slot="fee">
              <div style="margin-right: 0">
                <template v-if="row.min != row.max">
                  <span>{{ row.min }}%</span>-<span>{{ row.max }}%</span>
                </template>
                <span v-else>{{ row.min }}%</span>
              </div>
            </template>
            <template slot-scope="{ row }" slot="commissionMethod">
              <Select v-model="row.commissionMethod" style="width: 160px" @on-change="changeCommissionMethod($event, row)">
                <Option value="1">规模保费*费率</Option>
                <Option value="2">公司标保*费率</Option>
              </Select>
            </template>
            <template slot-scope="{ row }" slot="sellTypeSlot">
              <div class="sellTypeColumn" v-if="row.sellType">
                <Tag color="blue" v-if="row.sellType.includes('1')">网销</Tag>
                <Tag color="blue" v-if="row.sellType.includes('2')">电销</Tag>
                <Tag color="blue" v-if="row.sellType.includes('3')">经代</Tag>
              </div>
              <div v-else>/</div>
            </template>
            <template slot-scope="{ row }" slot="action">
              <div class="detail">
                <!-- <div @click="showDemand(row)">
                                    <span>申请对接</span>
                                    </div> -->
                <div v-if="$units.pointAction('pro_2_5')" @click="showCommission(row)">
                  <span>费用</span>
                </div>
                <div v-if="$units.pointAction('pro_2_6') && (row.sourceType != 2 || (row.sourceType == 2 && row.insureUrl))" @click="goLinkList(row)">
                  <span>获取投保链接</span>
                </div>
                <div v-if="$units.pointAction('pro_2_7')" @click="showEdit({ ...row, isCopy: 1 })">
                  <span>复制</span>
                </div>
                <div v-if="row.sourceType == 2 && $units.pointAction('pro_2_3')" @click="showDelete(row)">
                  <span class="red">删除</span>
                </div>
              </div>
            </template>
          </Table>
          <div class="pageBox">
            <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" 
            show-sizer :page-size-opts="[10, 20, 30, 50, 100]" @on-page-size-change="pageSizeChange"/>
          </div>
        </div>
      </div>
    </div>
    <demandModal ref="demandModal"></demandModal>
    <Modal v-model="info" title="说明" :footer-hide="true" width="600" class="my-modal top">
      <div style="margin-top: 10px">
        商品服务费率联动调整说明 当上级服务费调整时，系统将自动按照原费率在上级可支配费率中的占比进行调整
        （如，上级可支配为80%，下级为40%，即下级占上级费率的50%，当上级下调至30%时，系统将自动将下级调至15%，上级剩余15%）
      </div>
    </Modal>
    <!-- 导入 -->
    <import-tool ref="importTool" @success="reload()"></import-tool>

    <!-- 导出历史费率 -->
    <daochu-fee-modal ref="daochuFeeModal"></daochu-fee-modal>
    <!-- 导入费率 -->
    <import-Product-fee ref="importProductFee" pageType="library"></import-Product-fee>
  </div>
</template>

<script>
import config from './index.config.js';
import selectRegion from '@/components/commons/selectRegion';
import importTool from '@/components/commons/importTool/index2';
import { mapState } from 'vuex';
import { pageTool, common } from '@/api/mixins';
import demandModal from './components/demandModal';
import daochuFeeModal from '@/components/commons/feeTemplate/daochuFeeModal';
import importProductFee from '@/components/commons/importProductFee/index';
import { productManageEdit } from '@/api/httpList';
export default {
  name: 'productManager.index',
  components: {
    importTool,
    demandModal,
    importProductFee,
    daochuFeeModal,
    selectRegion
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mixins: [pageTool, common, config],
  data() {
    return {
      info: false,
      searchMore: true,
      productThemeList: [],
      supplierList: [],
      companyList: [],
      type: '1', //详情类型
      //表单搜索字段
      searchParams: {
        isThereRate: '',
        publishStatus: '2',
        salesStatus: '2'
      },
      tableData: [],
      columns: [],
      selectArr: [], //选中的产品
      isAll: false
    };
  },
  methods: {
    reload() {
      this.getList();
    },
    // 导入费率
    importProductFee() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.$refs.importProductFee.open({
        uploadUrl: '/buz/commission/config/importCommissionByMerId',
        downloadUrl: '/buz/commission/config/export',
        downloadParams: {
          nodeType: 1,
          id: userInfo.organId,
          handleSource: 1
        }
      });
    },
    // 获取导入产品费率进度
    getImportFeeProgress() {
      this.$refs.importProductFee.getProgress();
    },
    // 导入
    importData() {
      this.$refs.importTool.open({
        params: {},
        uploadParams: {},
        template: '/buz/productBase/downloadTemplate',
        templateName: '产品导入模板.xlsx',
        uploadUrl: '/buz/productBase/importProduct'
      });
    },
    goLinkList(row) {
      if (row.isSalePermission != 1 && row.sourceType == 3) {
        //团险权限
        return this.$notice.error('暂无该产品销售权限，请联系您的销售支持');
      }
      this.$router.push({
        name: 'productManagerInsuranceLink',
        query: {
          productCode: row.productCode,
          isGift: row.isGift,
          insureType: row.insureType,
          backUrl:'/productResource/productManager'
        }
      });
    },
    // 导出费率接口
    exportFee() {
      let data = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(data);
      this.$units.downloadFile('/buz/commission/config/export', data, 'POST', '', 'pro_2_9');
    },
    // 导出历史费率接口
    exportHistoryFee() {
      const data = JSON.parse(JSON.stringify(this.searchParams));
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.setListParams(data);
      data.nodeType = 1;
      data.handleSource = 2;
      data.id = userInfo.organId;
      data.apiPermissionCode = 'pro_2_9';
      this.$refs.daochuFeeModal.open(data);
    },
    // 活动单导出
    exportToExcel() {
      let data = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(data);
      this.$units.downloadFile('/buz/productBase/export', data, 'POST', '', 'pro_2_8');
    },
    //险种分类
    getProductTheme() {
      this.$http({
        url: '/buz/productTheme/array/first',
        type: 'GET',
        data: {}
      }).then(res => {
        //赠险公司列表初始化
        this.productThemeList = res.data;
      });
    },
    showDemand(row) {
      this.$refs.demandModal.open(row);
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all';
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list';
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then(res => {
          this.supplierList = res.data;
        });
      }
    },
    //列表保险公司
    geCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        //赠险公司列表初始化
        this.companyList = res.data;
      });
    },
    showEdit(row = {}) {
      if (row.isCopy == 1) {
        this.openPageTabTags('/productResource/productManager/productAdd', {
          id: row.id,
          code: row.productCode,
          isCopy: row.isCopy,
          timeStr: new Date().getTime()
        });
      } else if ((row.sourceType != 2 && row.id) || row.dockChannel == 3) {
        //平台产品/凤栖回传产品只能查看详情
        this.openPageTabTags('/productResource/productManager/productDetail', {
          id: row.id,
          code: row.productCode,
          isCopy: row.isCopy,
          timeStr: new Date().getTime()
        });
      } else if (row.id) {
        this.openPageTabTags('/productResource/productManager/productEdit', {
          id: row.id,
          code: row.productCode,
          isCopy: row.isCopy,
          timeStr: new Date().getTime()
        });
      } else {
        this.openPageTabTags('/productResource/productManager/productAdd', { timeStr: new Date().getTime() });
      }
    },
    changeCommissionMethod(value, row) {
      productManageEdit({
        id: row.id,
        productCode: row.productCode,
        commissionMethod: value
      });
    },
    //编辑是否上架
    editStatus(row) {
      return new Promise(resolve => {
        this.$Modal.confirm({
          title: row.publishStatus == 2 ? '是否确定下架？' : '是否确定上架？',
          onOk: () => {
            productManageEdit({
              id: row.id,
              productCode: row.productCode,
              publishStatus: row.publishStatus == 2 ? 1 : 2
            }).then(res => {
              this.$Message.success('修改成功');
              this.getList();
              resolve();
            });
          }
        });
      });
    },
    showDelete(row) {
      this.$Modal.confirm({
        title: '确定删除吗？',
        onOk: () => {
          this.$http({
            url: '/buz/productBase/offline/del',
            type: 'GET',
            data: { id: row.id },
            apiPermissionCode: 'pro_2_3'
          }).then(res => {
            this.$Message.success('删除成功');
            this.getList();
          });
        }
      });
    },
    toProductList() {
      this.$router.push({
        name: 'productManager.product',
        query: {}
      });
    },
    showCommission(row) {
      sessionStorage.feeUpstreamCofnigQuery = JSON.stringify({
        productName: row.productName,
        productCode: row.productCode,
        supplierType: row.supplierType,
        supplierId: row.supplierId,
        supplierName: row.source
      });
      this.openPageTabTags('/productResource/feeUpstreamCofnig', {
        sourceType: row.sourceType,
        fromPage: 'productManager'
      });
    },
    setReqParams(params) {
      params.apiPermissionCode = 'pro_2_0';
    },
    setListParams(params) {
      // if (params.sellType && params.sellType.length > 0) {
      //     params.sellType =
      //         params.sellType.length > 1 ? params.sellType.join('|') : params.sellType.length == 1 ? params.sellType.join(',') : '';
      // } else {
      //     delete params.sellType;
      // }
      if (params.insureType && params.insureType.length > 0) {
        params.insureType = params.insureType.length > 1 ? params.insureType.join('|') : params.insureType.length == 1 ? params.insureType.join(',') : '';
      } else {
        delete params.insureType;
      }
    },
    // 批量上下架
    batch(flag) {
      if (this.selectArr.length == 0 && !this.isAll) {
        this.$notice.msg('请至少选择一个产品');
        return;
      }
      this.$Modal.confirm({
        title: `确定${flag ? '上架' : '下架'}${this.isAll ? this.total : this.selectArr.length}款产品？`,
        onOk: () => {
          this.deleteProduct(this.selectArr, flag);
        }
      });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 选中某个
    selectRow(curSelectArr) {
      const codes = curSelectArr.map(item => item.id); //当前页勾选的
      const selectCodes = this.selectArr.map(item => item); //已经添加的数据
      this.tableData.forEach(item => {
        if (codes.includes(item.id) && !selectCodes.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item.id);
          selectCodes.push(item.id);
        } else if (!codes.includes(item.id) && selectCodes.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectCodes.indexOf(item.id), 1);
          selectCodes.splice(selectCodes.indexOf(item.id), 1);
        }
      });
    },
    searchAjax() {
      this.isAll = false; //全选
      this.selectArr = [];
      this.listLoading = true;
      this.pageNum = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        this.getList();
      }, 500);
    },
    deleteProduct(idList, flag) {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.listLoading = true;
      this.$http({
        url: '/buz/productBase/batchUpdatePublishStatus',
        type: 'post',
        data: {
          updatePublishStatus: flag ? 2 : 1,
          idList,
          ...params
        }
      })
        .then(res => {
          this.isAll = false; //全选
          this.selectArr = [];
          this.getList();
          this.$notice.success(`产品批量${flag ? '上架' : '下架'}成功`);
          // this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    listCallback(res) {
      res.data.forEach(item => {
        this.selectArr.forEach(item2 => {
          if (item.id == item2) {
            item._checked = true;
          }
        });
        if (this.isAll) {
          item._checked = true;
          item._disabled = true;
        }
      });
    }
  },
  activated() {
    if (!this.$units.superviseShowVal()) {
      this.searchParams.supplierType = '1';
    }
    if (this.$route.query.isThereRate === '' || this.$route.query.isThereRate) {
      this.searchParams.isThereRate = this.$route.query.isThereRate;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    if (this.$route.query.publishStatus === '' || this.$route.query.publishStatus) {
      this.searchParams.publishStatus = this.$route.query.publishStatus;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    if (this.$route.query.salesStatus === '' || this.$route.query.salesStatus) {
      this.searchParams.salesStatus = this.$route.query.salesStatus;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    this.getList();
  },
  mounted() {
    this.getProductTheme();
    this.geCompanyList();
    this.getColumns();
    this.initListParams('/buz/productBase/read/list');
  }
};
</script>
<style lang="scss" scoped>
/deep/ .ivu-switch-disabled.ivu-switch-checked {
  opacity: 1;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px 30px !important;
}

/deep/.disabled {
  pointer-events: none;
  text-decoration: none;
  color: #999;
}

/deep/ .formGroup {
  position: relative;

  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }

  padding: 0;

  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3c464f;
  }
}

.pageBox {
  margin-top: 20px;
}

.btn-wrap {
  margin: 0 0 20px 0;
  min-height: 20px;
}

body .ivu-btn-ghost {
  background-color: #fff;
}
@import './index.scss';
</style>
